class DrawerAccountForms extends window.BAO.CustomElement() {
  connectedCallback () {
    // ensure any parent logic runs
    if (super.connectedCallback) super.connectedCallback()
    // cache references to forms and URLs
    this.loginForm = this.els['login-form'].element
    this.registerForm = this.els['register-form'].element
    this.accountUrl =
      this.dataset && this.dataset.accountUrl
        ? this.dataset.accountUrl
        : '/account'
  }

  setupListeners () {
    super.setupListeners()
    // lookup the form once els is fully populated
    const rawForm = this.els['login-form']
    this.loginForm = rawForm?.element || rawForm
    if (this.els['login-form']?.exists) {
      this.loginForm.addEventListener('submit', event =>
        this.onSubmitLogin(event),
      )
    }

    const rawFormRegister = this.els['register-form']
    this.registerForm = rawFormRegister?.element || rawFormRegister
    if (this.els['register-form']?.exists) {
      this.registerForm.addEventListener('submit', event =>
        this.onSubmitRegister(event),
      )
    }
  }

  /**
   * Handles the submission of the login form by posting the form to Shopify.
   * If the response indicates a successful login we redirect to the account page.
   * If the response includes errors we display them within the drawer without a page refresh.
   * @param {SubmitEvent} event
   */
  async onSubmitLogin (event) {
    event.preventDefault()
    this.log('Login form submitted')

    const form = event.target
    const formData = new FormData(form)

    this.clearLoginErrors()

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest',
        },
        redirect: 'follow',
      })

      const html = await response.text()
      const parser = new window.DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      let message = null

      const node = doc.querySelector(
        '#customer_login [data-private-sale-el="login.error"]',
      )
      if (node) {
        message = node.textContent.trim()
      }

      if (message) {
        this.renderLoginErrors([message])

        return
      }

      // if no errors found treat as success
      window.location.href =
        this.loginFormReturnUrl || this.accountUrl || response.url
    } catch (error) {
      console.error('Login request failed', error)
      this.renderLoginErrors(['Something went wrong. Please try again.'])
    }
  }

  /**
   * Removes any existing error container from the login form.
   */
  clearLoginErrors () {
    if (!this.loginForm) return

    const existing = this.loginForm.querySelector('[data-login-error]')
    if (existing) existing.remove()
  }

  /**
   * Creates or updates the error container and populates it with messages.
   * @param {string[]} messages
   */
  renderLoginErrors (messages) {
    if (!this.loginForm) return

    let container = this.loginForm.querySelector('[data-login-error]')
    if (!container) {
      container = document.createElement('div')
      container.setAttribute('data-login-error', '')
      container.className = 'frm-Form_Validation'

      this.loginForm.prepend(container)
    }
    container.innerHTML = messages
      .map(msg => {
        return `<p class="frm-Form_ValidationText frm-Form_ValidationText-error fz-12_140">${msg}</p>`
      })
      .join('')
  }

  async onSubmitRegister (event) {
    this.log('Register form submitted')

    const form = event.target
    const formData = new FormData(form)

    this.clearRegisterErrors()

    try {
      event.preventDefault()

      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest',
        },
        redirect: 'follow',
      })

      // Handle errors from the registration form
      const html = await response.text()
      const parser = new window.DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      let message = null

      const node = doc.querySelector(
        '#create_customer [data-private-sale-el="login.error"]',
      )
      if (node) {
        message = node.textContent.trim()
      }

      if (message) {
        this.renderRegisterErrors([message])

        return
      }

      window.location.href =
        this.registerFormReturnUrl || this.accountUrl || response.url
    } catch (error) {
      event.preventDefault()

      console.error('Registration request failed', error)
      this.renderRegisterErrors(['Something went wrong. Please try again.'])
    }
  }

  renderRegisterErrors (messages) {
    if (!this.registerForm) return

    let container = this.registerForm.querySelector('[data-register-error]')
    if (!container) {
      container = document.createElement('div')
      container.setAttribute('data-register-error', '')
      container.className = 'frm-Form_Validation'
      // insert at the top of the form so errors are visible immediately
      this.registerForm.prepend(container)
    }
    container.innerHTML = messages
      .map(msg => {
        return `<p class="frm-Form_ValidationText frm-Form_ValidationText-error fz-12_140">${msg}</p>`
      })
      .join('')
  }

  clearRegisterErrors () {
    if (!this.registerForm) return

    const existing = this.registerForm.querySelector('[data-register-error]')
    if (existing) existing.remove()
  }

  get loginFormReturnUrl () {
    const returnToInput = this.loginForm?.querySelector(
      'input[type="hidden"][name="return_to"]',
    )
    if (!returnToInput || !this.dataset.routesUrl) return

    return `${this.dataset.shopUrl}${returnToInput.value}${
      this.dataset.reopenOnLogin === 'true' ? '?ad=1' : ''
    }`
  }
}

if (!customElements.get('drawer-account-forms')) {
  customElements.define('drawer-account-forms', DrawerAccountForms)
}
